const angularModule = angular.module('com.comtrade.shared.sharedModule.ctxContentSwitcher', []);

angularModule.component('ctxContentSwitcher', require('./ctxContentSwitcher.component'));
angularModule.component('ctxSwitchPanel', require('./ctxSwitchPanel.component'));
angularModule.service('contentSwitcherService', require('./ctxContentSwitcher.service'));
angularModule.animation('.ctx-switch-panel-content', require('./ctxSwitcher.animation'));

module.exports = angularModule;



// WEBPACK FOOTER //
// ./src/shared/ctxContentSwitcher/ctxContentSwitcher.module.js